import client from '@/clients/restaurant/restaurant-client';
import { PlanResponse } from '@/lib/types/restaurant/PricingPlan';
import { SubscriptionsResponse } from '@/lib/types/restaurant/SubscriptionsType';
import Qs from 'qs';

export const getPlans = (filter: object | null = null) =>
  client.get<PlanResponse>('/plans', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });

export const getPlanDetails = (id: string) => client.get(`/plans/${id}`);

export const buySubscription = (data: unknown) =>
  client.post(`/subscriptions`, data);

export const paySetupFee = (data: unknown) =>
  client.post(`/subscriptions/pay-setup-fee`, data);

export const cancelSubscription = (planId: string | number) =>
  client.post(`/subscriptions/current/cancel`);

export const getSubscriptionDetails = (planId: string | number) =>
  client.get<SubscriptionsResponse>(`/subscriptions/${planId}`);

export const getSubscriptionPayments = () =>
  client.get(`/subscriptions/payments`);

export const executeSubPayment = (
  sub_id: string,
  sub_token: string,
  data: unknown
) => client.post(`/subscriptions/activate/${sub_id}/${sub_token}`, data);

export const executeSetupFeePayment = (
  setup_fee_id: string,
  setup_fee_token: string,
  data: unknown
) =>
  client.post(
    `/subscriptions/setup-fee/capture/${setup_fee_id}/${setup_fee_token}`,
    data
  );

export const downloadSetupFeeInvoice = (id: string | number) =>
  client.get(`/subscriptions/payment/invoices/setup-fee/${id}/download`);

export const downloadSubPaymentInvoice = (id: string | number) =>
  client.get(`/subscriptions/payment/invoices/${id}/download`);

export const getSpecialPlans = (code: string) =>
  client.get<PlanResponse>(`/plans/special/${code}`);
